@if (serviceordre) {
  <form [formGroup]="serviceOrdreForm" autocomplete="off">
    <div [class.flex-wrap]="!expandPosteringerTabel" [class.flex-wrap-wrapper]="expandPosteringerTabel">
      <div [class.flex-wrap__col--40]="!expandPosteringerTabel" [class.flex-wrap__col--100]="expandPosteringerTabel">
        @if (visBemaerkninger) {
          <div class="order__bemaerkninger">
            <h2 class="orange flex-wrap flex-wrap--align-center cursor-pointer" (click)="bemaerkningerShowing = !bemaerkningerShowing">
              <mat-icon svgIcon="obs-solid"></mat-icon>
              &nbsp; Bemærkninger
              @if (!bemaerkningerShowing) {
                <mat-icon>expand_more</mat-icon>
              }
              @if (bemaerkningerShowing) {
                <mat-icon>expand_less</mat-icon>
              }
            </h2>
            @if (bemaerkningerShowing) {
              <div>
                @if (serviceordre.tags?.length) {
                  <div>
                    <mat-chip-listbox #chipList aria-label="Tags">
                      @for (tag of serviceordre.tags; track tag) {
                        <mat-chip-option class="orange-bg">
                          {{ tag.text }}
                        </mat-chip-option>
                      }
                    </mat-chip-listbox>
                  </div>
                }
                @if (visManuelGodkendelse) {
                  <h4 class="manuel-warning no-margin-top no-margin-bottom orange">
                    Afregningen er udtaget til manuel godkendelse af følgende årsager:
                  </h4>
                  <ul class="orange">
                    @for (validationError of afregningAutoApprovalResult?.errors; track validationError) {
                      <li>
                        {{ validationError.errorMessage }}
                      </li>
                    }
                  </ul>
                }
                <app-recent-changes [changes]="recentChanges"></app-recent-changes>
              </div>
            }
          </div>
        }
        <div>
          <h2>Beskrivelse</h2>
          <p>
            {{ serviceordre.description }}
          </p>
        </div>
        <div class="order__splitview">
          <div>
            <h2>Noter til S-partner</h2>
            @if (serviceordre?.fastOrdreNote) {
              <h3>Fast note</h3>
              <p>
                {{ serviceordre?.fastOrdreNote }}
              </p>
            }
          </div>
          <div>
            <h2>Bemærk. fra S-partner</h2>
            @if (serviceOrdreAfregning?.remarkToCustomerservice) {
              <h3>Til kundeservice</h3>
              <p [innerHTML]="$safeNavigationMigration(serviceOrdreAfregning?.remarkToCustomerservice)"></p>
            }
            @if (serviceordre?.afvistReturNote) {
              <h3>Afvisningsnote</h3>
              <p>
                {{ serviceordre?.afvistReturNote }}
              </p>
            }
            @if (serviceOrdreAfregning?.remarkToServicereport) {
              <h3>Til servicerapport</h3>
              <p>
                {{ serviceOrdreAfregning?.remarkToServicereport }}
              </p>
            }
          </div>
        </div>
      </div>
      <div [class.collapsed]="!expandPosteringerTabel" [class.expanded]="expandPosteringerTabel">
        <div class="flex-wrap flex-wrap--align-center">
          <h2 class="flex">
            Posteringer
            @if (isServiceOrdreEditable && serviceOrdreAfregning) {
              <button
                class="btn-icon blue btn-add-small margin--left-s"
                type="button"
                (click)="addPosteringsLinje()"
                matTooltip="Tilføj afregningslinie"
                >
                <mat-icon svgIcon="add-solid" class="blue"></mat-icon>
              </button>
            }
          </h2>
          <div class="margin--left-auto margin--bottom-xs">
            <mat-chip-listbox #chipList aria-label="Tags">
              @if (isLeasing) {
                <mat-chip-option class="trans-red-bg">
                  <mat-icon svgIcon="obs-solid" class="red margin--right-xs"></mat-icon>
                  Leasing
                </mat-chip-option>
              }
              @if (isNarvarme) {
                <mat-chip-option class="trans-red-bg">
                  <mat-icon svgIcon="obs-solid" class="red margin--right-xs"></mat-icon>
                  Nærvarme
                </mat-chip-option>
              }
              @if (isGasfyrTryghed) {
                <mat-chip-option class="trans-red-bg">
                  <mat-icon svgIcon="obs-solid" class="red margin--right-xs"></mat-icon>
                  Gasfyr Tryghed
                </mat-chip-option>
              }
              <app-garantiaftale-tag [serviceaftale]="serviceAftale"></app-garantiaftale-tag>
            </mat-chip-listbox>
          </div>
          <div class="expand-button">
            <button
              class="btn-icon blue"
              [matTooltip]="!expandPosteringerTabel ? 'Udvid posterings tabel' : 'Kollaps posterings tabel'"
              (click)="expandPosteringerTabel = !expandPosteringerTabel"
              >
              @if (!expandPosteringerTabel) {
                <mat-icon>swap_horiz</mat-icon>
              }
              @if (expandPosteringerTabel) {
                <mat-icon>compare_arrows</mat-icon>
              }
            </button>
          </div>
        </div>
        @if (serviceOrdreAfregning?.automaticApprovedForAccounting) {
          <span class="orange tiny-text icon-with-text margin--bottom-xs">
            <mat-icon svgIcon="obs-solid" class="icon-24"></mat-icon>
            Afregningen er blevet automatisk godkendt
          </span>
        }
        @if (serviceOrdreAfregning) {
          <app-posterings-list
            [posteringsLinjer]="$safeNavigationMigration(serviceOrdreAfregning?.serviceordreAfregningPostList)"
            [editable]="isServiceOrdreEditable"
            [isErhverv]="isErhverv"
            [isExpanded]="expandPosteringerTabel"
            (linjeEdited)="editLinie($event)"
            (linjeDeleted)="deleteLinje($event)"
            (linierChanged)="linierChanged($event)"
          ></app-posterings-list>
        }
        <div class="card card--no-padding no-maxwidth">
          @if (!serviceOrdreAfregning) {
            <div class="card__padded-content">
              Der er ingen afregning på ordren, og posteringer kan derfor ikke redigeres.
            </div>
          }
        </div>
        <div class="card nolimits">
          <div class="data">
            <div class="data__lbl medium special-lbl">Fakturanote</div>
            <div class="data__val data__val--full">
              <mat-form-field appearance="outline" class="mdc-textarea-fix">
                <textarea formControlName="fakturaNote" matInput rows="4" (blur)="UpdateFakturaNote()"></textarea>
                <mat-hint align="end">
                  <app-character-count [control]="fakturaNote" [maxlength]="500"></app-character-count>
                </mat-hint>
                @if (fakturaNote.hasError('maxlength')) {
                  <mat-error>Intern note må højest være 500 karakterer lang</mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
}
